import CatalogProductsRecommended from '@/themes/base/components/catalog/CatalogProductsRecommended'

export default {
  extends: CatalogProductsRecommended,
}
